"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKActionBar = void 0;
var React = __importStar(require("react"));
var use_resize_observer_1 = __importDefault(require("use-resize-observer"));
var hooks_1 = require("../../common/hooks");
var GKActionButtons_1 = require("./GKActionButtons");
require("./GKActionBar.css");
/**
 * Action Bar component - Used to contain information and buttions when those actions pertain
 * to a large poriton (or multiple) portions of the screen and therefore do not make sense inline.
 * Can be used as a child of any GKLayoutContainer - including GKLayoutShell.
 *
 * @remarks
 * Map overlay behavior is TBD. For now, the bar will always appear at the bottom of
 * the GKLayoutContainer
 */
var GKActionBar = function (props) {
    // Intentionally destructured from otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-action-bar",
        className: props.open ? "open" : "closed",
        open: false,
    }), children = _a.children, actions = _a.actions, open = _a.open, style = _a.style, otherProps = __rest(_a, ["children", "actions", "open", "style"]);
    var containerRef = React.useRef(null);
    var _b = (0, use_resize_observer_1.default)({
        ref: containerRef,
    }).height, height = _b === void 0 ? 0 : _b;
    var calculatedHeight = open ? "calc(" + height + "px + 2rem)" : "0px";
    var ActionBar = (React.createElement("div", __assign({}, otherProps, { style: Object.assign({}, style, { height: calculatedHeight }) }),
        React.createElement("div", { ref: containerRef, className: "gk-action-bar-contents d-flex flex-column flex-lg-row p-3 align-items-stretch align-items-lg-center" },
            React.createElement("div", { className: "mb-2 mb-lg-0 flex-grow-1" }, children),
            actions && React.createElement(GKActionButtons_1.ActionButtons, { actions: actions }))));
    return ActionBar;
};
exports.GKActionBar = GKActionBar;
exports.default = exports.GKActionBar;
